import { Outlet, useParams } from 'react-router-dom'
import { useAuthStore } from '@/stores/auth'

export function TenantLayout() {
  const { tenantId } = useParams<{ tenantId: string }>()
  const activeTenantId = useAuthStore((s) => s.activeTenantId)

  // Pure gate: hold the children back until the session scope matches the URL, so
  // tenant pages never flash the super-admin view or fire queries without the
  // X-Tenant-ID header. The scope itself is written by useTenantScopeSync, one
  // layer up — this layout sits inside the route Suspense boundary, and a writer
  // in here would be torn down and re-run every time a lazy chunk suspends.
  if (tenantId && activeTenantId !== tenantId) {
    return null
  }

  return <Outlet />
}
